export default "__VITE_ASSET__97efc583__"